import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getUserDetailRequest, getUserDetailRequestError, getUserDetailRequestSuccess } from "../../slices/user-management/UserDetailSlice";

export const GetUserDetailAPI = (data) => async (dispatch) => {


    const queryParams = new URLSearchParams({
        userId: data.userId
    }).toString();

    const urlWithParams = `${endpoints.userDetail}?${queryParams}`;
    try {
        dispatch(getUserDetailRequest());
        axiosInstance({
            method: "GET",
            url: urlWithParams,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getUserDetailRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getUserDetailRequestError(_error));
            });
    } catch (error) { }
};
